import React from 'react';
import {Plugins, Expressions, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {List} from 'immutable';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
} from '@packages/utilities/data-utils';

const maybeAddCurrent =
  (current: unknown, dataTab: unknown) => (classes: List<string>) => {
    return current === dataTab ? classes.push('w--current') : classes;
  };

const TabsLink = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const dataTab = getInPojo(data, ['attr', 'data-w-tab']);

    const tabsLinkClasses = classes
      .push('w-tab-link')
      .update(maybeAddCurrent(context.get('current'), dataTab));

    return (
      <a {...generateAttributes(attributes, tabsLinkClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </a>
    );
  }
);

const config = createDevlinkAtom({
  constraints: {
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
    parent: [
      {
        is: 'TabsMenu',
        name: 'Non-Tabs-Menu Item',
        rule: 'RequireOnly',
      },
    ],
  },
  displayName: {
    type: 'Derived',
    defaultValue: 'Tab Link',
    getFromElement: (element) => {
      const tabName = Expressions.getElementDataAt(
        element,
        [
          {in: 'Record', at: 'attr'},
          {in: 'Record', at: 'data-w-tab'},
        ],
        'Text',
        ''
      );
      return `Tab Link [${tabName}]`;
    },
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: false,
  render: TabsLink,
  fields: {
    attr: TRecord({
      'data-w-tab': TText,
    }),
    children: TListOfElement,
  },
});

export default config;
